import React, { useContext } from "react";
import { UserContext } from "../../utils/userContext";
import { isSuperAdmin, isCustomerAdmin } from "../../utils/roles";
import AccessDenied from "../ui/AccessDenied";

const withCustomerAccess = (WrappedComponent) => {
  return (props) => {
    const { user, isLoading } = useContext(UserContext);
    if (isLoading) return null;
    if (!isSuperAdmin(user) && !isCustomerAdmin(user)) {
      return <AccessDenied message="Access denied." />;
    }
    return <WrappedComponent {...props} />;
  };
};

export default withCustomerAccess;
